import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { BRAND_NAME } from '../../lib/brand';
import BrandWordmark from './BrandWordmark';

const Logo = ({ className = '', size = 'nav' }) => {
  return (
    <Link
      to="/"
      className={cn(
        'inline-flex items-center no-underline transition-opacity duration-300 hover:opacity-70',
        className
      )}
      aria-label={`${BRAND_NAME} Ana Sayfa`}
    >
      <BrandWordmark size={size} />
    </Link>
  );
};

export default Logo;
